import { useEffect, useState } from 'react'
import { BANK_BUILD_INTERVAL_MS, EXAM_STAGES } from '../constants/config'
import { STRINGS } from '../constants/strings'
import { NISM_UNITS } from '../data/mockApi'
import { useExam } from '../hooks'

export default function BankBuildingScreen() {
  const { state, dispatch } = useExam()
  const [step, setStep] = useState(0)

  useEffect(() => {
    const total    = NISM_UNITS.length
    const interval = setInterval(() => { // eslint-disable-line
      setStep(s => {
        const next = s + 1
        if (next >= total) {
          clearInterval(interval)
          setTimeout(() => {
            dispatch({ type: 'MARK_BANK_BUILT', payload: state.difficulty })
            dispatch({ type: 'SET_STAGE', payload: EXAM_STAGES.SETUP })
          }, 800)
        }
        return next
      })
    }, BANK_BUILD_INTERVAL_MS)
    return () => clearInterval(interval)
  }, [])

  const pct  = Math.min(step / NISM_UNITS.length, 1)
  const unit = NISM_UNITS[Math.min(step, NISM_UNITS.length - 1)]

  return (
    <div className="max-w-lg mx-auto px-4 sm:px-8 py-16 sm:py-24 text-center animate-fade-up">
      {/* Animated ring */}
      <div className="relative w-24 h-24 mx-auto mb-8">
        <svg viewBox="0 0 96 96" className="w-full h-full -rotate-90">
          <circle cx="48" cy="48" r="40" fill="none" stroke="var(--surface-2)" strokeWidth="6" />
          <circle
            cx="48" cy="48" r="40"
            fill="none" stroke="var(--brand)" strokeWidth="6"
            strokeLinecap="round"
            strokeDasharray={`${2 * Math.PI * 40}`}
            strokeDashoffset={`${2 * Math.PI * 40 * (1 - pct)}`}
            style={{ transition: 'stroke-dashoffset 0.35s ease' }}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center text-lg font-bold text-[var(--text-1)]">
          {Math.round(pct * 100)}%
        </div>
      </div>

      <h2 className="text-2xl font-bold text-[var(--text-1)] mb-2">{STRINGS.bankBuilding.title}</h2>
      <p className="text-sm text-[var(--text-2)] mb-8 leading-relaxed">{STRINGS.bankBuilding.subtitle}</p>

      {/* Unit list */}
      <div className="card p-4 text-left space-y-2">
        {NISM_UNITS.map((u, i) => (
          <div key={u.unit} className={`flex items-center gap-3 text-xs transition-all ${i < step ? 'text-[var(--text-2)]' : i === step ? 'text-brand' : 'text-[var(--text-3)]'}`}>
            <span className="w-4 h-4 flex-shrink-0 flex items-center justify-center">
              {i < step ? '✓' : i === step ? <span className="w-2 h-2 rounded-full bg-brand animate-pulse" /> : <span className="w-2 h-2 rounded-full bg-[var(--surface-2)]" />}
            </span>
            <span>{u.name}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
